type EditIconProps = {
    className?: string;
    size?: number;
};

const EditIcon = ({ className, size = 16 }: EditIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            d="M2 12.0001H3.11636C3.34352 12.0001 3.4571 12.0001 3.56405 11.9742C3.65878 11.9512 3.74932 11.9131 3.83242 11.8612C3.92616 11.8028 4.00601 11.723 4.16573 11.5632L12.3333 3.39568C12.8856 2.84339 12.8856 1.94797 12.3333 1.39568C11.781 0.843395 10.8856 0.843397 10.3333 1.39568L2.16578 9.56326C2.00606 9.72298 1.9262 9.80284 1.86787 9.89657C1.81594 9.97968 1.77779 10.0702 1.75479 10.165C1.72894 10.2719 1.72894 10.3855 1.72894 10.6127V12.0001H2ZM2 12.0001H14"
            stroke="#18181B"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default EditIcon;
